export const scheduleAppraisalAllowanceRefresh = (
  resetAt: string,
  refresh: () => void,
  now: number,
  schedule: (callback: () => void, delay: number) => number,
): number | undefined => {
  if (!resetAt) return undefined;

  const delay = new Date(resetAt).getTime() - now + 1000;
  if (delay <= 0) {
    refresh();
    return undefined;
  }

  return schedule(refresh, delay);
};
